import { render, staticRenderFns } from "./termsService.vue?vue&type=template&id=a4161036&scoped=true&"
import script from "./termsService.vue?vue&type=script&lang=js&"
export * from "./termsService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4161036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4161036')) {
      api.createRecord('a4161036', component.options)
    } else {
      api.reload('a4161036', component.options)
    }
    module.hot.accept("./termsService.vue?vue&type=template&id=a4161036&scoped=true&", function () {
      api.rerender('a4161036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/termsService.vue"
export default component.exports